"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getZapsForDisplay = exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _utils = require("./utils");

var _AppCard = _interopRequireDefault(require("./components/AppCard"));

var _ZapTemplateCard = require("./components/zapier/ZapTemplateCard");

var _constants = require("@insided/shared/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getZapsForDisplay = function getZapsForDisplay() {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  return require("./components/zapier/".concat(_constants.ZAPIER_TEMPLATE_JSON_PATH)).filter(function (zap) {
    if ((0, _utils.isIntercomAppVisible)()) {
      return zap.title !== 'Intercom';
    }

    return zap;
  });
};

exports.getZapsForDisplay = getZapsForDisplay;

var IntegrationApps = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IntegrationApps, _Component);

  var _super = _createSuper(IntegrationApps);

  function IntegrationApps() {
    var _this;

    (0, _classCallCheck2.default)(this, IntegrationApps);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      appList: _utils.appsMap
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchInstallationStatus", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(key) {
        var result, appList;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _utils.checkInstallationMap[key]();

              case 2:
                result = _context.sent;
                appList = _this.state.appList;

                if ((0, _typeof2.default)(result) === 'object' && result !== null) {
                  _this.setState({
                    appList: _objectSpread(_objectSpread({}, appList), {}, (0, _defineProperty2.default)({}, key, _objectSpread(_objectSpread({}, appList[key]), result)))
                  });
                } else {
                  _this.setState({
                    appList: _objectSpread(_objectSpread({}, appList), {}, (0, _defineProperty2.default)({}, key, _objectSpread(_objectSpread({}, appList[key]), {}, {
                      isInstalled: !!result
                    })))
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(IntegrationApps, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _utils.appOrder.filter(function (key) {
                  return _utils.appsMap[key].isVisible;
                }).forEach(function (key) {
                  _this2.fetchInstallationStatus(key);
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var appList = this.state.appList;
      var zapsList = getZapsForDisplay();
      return (0, _preact.h)("div", {
        className: "integration-apps-container"
      }, _utils.appOrder.map(function (key) {
        return (0, _preact.h)(_AppCard.default, (0, _extends2.default)({
          key: key
        }, appList[key]));
      }), zapsList.map(function (zap) {
        return (0, _preact.h)(_ZapTemplateCard.ZapTemplateCard, (0, _extends2.default)({
          key: zap.imageName
        }, zap));
      }));
    }
  }]);
  return IntegrationApps;
}(_preact.Component);

var _default = IntegrationApps;
exports.default = _default;